<template>
	<ModalBase modal-type="initial" @close="closing">
		<template #header>
			{{ $t('component.gdprModal.header') }}
		</template>
		<template #body>
			<div class="flex">
				<div class="w-3/4">
					<div class="text-xl">{{ $t('component.gdprModal.module_googleAnalytics.label') }}</div>
					<div class="text-sm">{{ $t('component.gdprModal.module_googleAnalytics.description') }}</div>
				</div>
				<div class="w-1/4 flex flex-wrap content-center justify-center">
					<button v-if="!analyticsDisabled"
							@click="disableTracking"
							class="bg-gray-300 p-2 px-4 shadow border hover:bg-gray-400">{{ $t('component.gdprModal.disable') }}</button>
					<button v-else
							@click="enableTracking"
							class="bg-gray-300 p-2 px-4 shadow border hover:bg-gray-400">{{ $t('component.gdprModal.enable') }}</button>
				</div>
			</div>
		</template>
		<template #footer>
			<div class="flex justify-end mt-4 border-t pt-4">
				<button @click="closing"
						class="bg-gray-300 p-2 px-4 shadow border hover:bg-gray-400">{{ $t('component.gdrpModal.close') }}</button>
			</div>
		</template>
	</ModalBase>
</template>

<script>
	import ModalBase from "../shared/ModalBase";
	import { mapGetters } from 'vuex';

    export default {
        name: "GdprModal",
		components: {
            ModalBase
		},
		computed: {
            ...mapGetters('app', {
                analyticsDisabled: 'analyticsDisabled'
			})
		},
		methods: {
            disableTracking() {
                this.$store.dispatch('app/disableAnalytics');
                this.$ga.disable();
			},

			enableTracking() {
                this.$store.dispatch('app/enableAnalytics');
                this.$ga.enable();
			},

            closing() {
                this.$emit('close');
			}
		}
    }
</script>

<style scoped>

</style>